import { Typography } from "@mui/material";

const NotFound = () => {
    return ( <>
    <Typography variant="h3">Page Not Found</Typography>
    </> );
}
 
export default NotFound;